import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';
import { BC } from 'model/modal-cms/bc';
import Swal from 'sweetalert2';
import { BC_detail } from 'model/modal-cms/detail_bc';
import { AdminService } from '../../../services/admin';

declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-form-valid-bc',
  templateUrl: './form-valid-bc.component.html',
  styleUrls: ['./form-valid-bc.component.scss']
})
export class FormValidBcComponent implements OnInit {
  id: any;
  text_title_confirm_bc: string;
  text_confirm_bc: string;
  mode_agent: number = 1;
  _BC_detail: BC_detail = new BC_detail(null);
  data_bc: any;
  mode_validation_bc_actuel: any;
   code: string = "ABCDEFghojklm123456789";
informationAgentDRHA:any

  constructor(public activatedRoute: ActivatedRoute, private router: Router, public cmsService: CMSService, public adminService: AdminService) {
    this.id = activatedRoute.snapshot.params['id'];
     
  }
  _bc: BC = new BC(null);
  ngOnInit() {
    this.getInfoBC();
    //this.list_num_bc();
  }


  

  getInfoBC() {
    this.cmsService.getInfoBc(this.id)
      .subscribe(data => {
       
        this._bc = data;
        this.text_title_confirm_bc = "Validation BC" ;
        this.text_confirm_bc =  this._bc.im + " : " + this._bc.info_patient +", Motif  : " + this._bc.motif +  ",  Nombre : " + this._bc.nombre;
        //this.confirm_bc();

        //get info drha
         this.adminService.getlisteWSDrh2(this._bc.im, this.code)
      .subscribe(data => {
        this.informationAgentDRHA = data;
        console.log("informationAgentDRHA" + data);
      }, err => {
        console.log(err);
      });


   
    
      },
        err => {
          console.log(err);
        })
  }

  list_num_bc() {
    this.cmsService.getNumBC(this.id)
      .subscribe(data => {
        this.data_bc = data
      },
        err => {
          console.log(err);
        })
  }


  //save num BC

  //confirmation
  confirm_bc() {
    this.cmsService.getInfoBc(this.id)
      .subscribe(data => {
        console.log(data);
        this._bc = data;
        this.text_title_confirm_bc = "Validation BC " ;
        this.text_confirm_bc = "Matricule : " + this._bc.im + " : " +", Etat agent : " + this._bc.etat_agent +  "Info patient : " + this._bc.info_patient + ", Motif : " + this._bc.motif + ", \n Nombre : " + this._bc.nombre;

        Swal.fire({
          title: this.text_title_confirm_bc,
          icon: 'info',
          text: this.text_confirm_bc,
          showCancelButton: true,
          confirmButtonText: 'Oui, Valider.',
          cancelButtonText: 'Non'
        }).then((result) => {
          if (result.value) {
            //ok btn  
            if (this.mode_validation_bc_actuel == 'R') {
              console.log("this.mode_validation_bc_actuel" + this.mode_validation_bc_actuel)
              //need create rejet in detai bc
              this._BC_detail.bc_id = this.id
              this.cmsService.saveNumBc(this._BC_detail).subscribe(data => {
                this._bc.etat_bc = "R";
                this.cmsService.updateBc(this._bc).subscribe(data => {
                  this.router.navigate(['list-bc']);
                  success_message.show();
                }, err => {
                })
              }, err => {
                console.log(err)
              })
            } else {
               this._BC_detail.bc_id = this.id
              this.cmsService.saveNumBc(this._BC_detail).subscribe(data => {
                   this.list_num_bc();
                  this._BC_detail = new BC_detail(null)
                  success_message.show();                  
              this._bc.etat_bc = "V";
              this.cmsService.updateBc(this._bc).subscribe(data => {
                this.router.navigate(['list-bc']);
                success_message.show();
              }, err => {
              })
            }, err => {
            })
            }

          } else if (result.dismiss === Swal.DismissReason.cancel) {
            //cancel btn
          }
        })
      },
        err => {
          console.log(err);
        })

  }






  SaveNumBC() {
    if (this._BC_detail.id_detail_bc == null) {
      this._BC_detail.bc_id = this.id
      this.cmsService.saveNumBc(this._BC_detail).subscribe(data => {
        this.list_num_bc();
        this._BC_detail = new BC_detail(null)
        success_message.show();
      }, err => {
      })
    } else {
      this.cmsService.updateNumBc(this._BC_detail).subscribe(data => {
        this.list_num_bc();
        this._BC_detail = new BC_detail(null)
        success_message.show();
      }, err => {
      })
    }

  }



  DeleteNumBc(i: BC_detail) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteNumBC(i.id_detail_bc)
          .subscribe(data => {
            this.list_num_bc();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }



  onChange(deviceValue) {
    console.log(deviceValue);
    if (deviceValue == "V") {
      this.mode_agent = 1;
      this._BC_detail.motif_rejet = "";
      this.mode_validation_bc_actuel = deviceValue;
    } else if (deviceValue == "R") {
      this.mode_agent = 2;
      this._BC_detail.num_bc = null;
      this.mode_validation_bc_actuel = deviceValue;
    }
  }

  annulerBC() {
    this.router.navigate(['list-bc']);
  }

}
